<template>
  <v-carousel
    :continuous="true"
    :cycle="true"
    :show-arrows="false"
    :hide-delimiters="true"
    height="96">
    <v-carousel-item
      v-for="(slide, i) in slides" :key="i"
      @click.stop="() => {
        $emit('tap');
        $emit('change', slide);
      }">
      <slot name="item" v-bind:slide="slide"></slot>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  name: 'Carousel',
  props: ['slides'],
  data: () => ({ ev: {} }),
};
</script>
